<template>
  <div class="flip-counter" :style="{ color: color, fontFamily: fontFamily, fontSize: fontSize }">
    <div v-for="(digit, index) in displayDigits" :key="index" class="digit-container">
      <transition name="flip" mode="out-in">
        <div :key="digit.value" class="digit" :class="{ 'is-decimal': digit.isDecimal }">
          {{ digit.value }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlipCounter',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    color: {
      type: String,
      default: '#333'
    },
    fontFamily: {
      type: String,
      default: 'Arial, sans-serif'
    },
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      displayDigits: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        this.updateDigits(newVal, oldVal)
      }
    }
  },
  methods: {
    updateDigits(newVal, oldVal) {
      const newDigits = this.parseNumber(newVal)
      const oldDigits = this.parseNumber(oldVal)

      // If lengths are different, just update without animation
      if (newDigits.length !== oldDigits.length) {
        this.displayDigits = newDigits
        return
      }

      this.displayDigits = newDigits
    },
    parseNumber(num) {
      if (num === null || num === undefined) num = 0
      const str = String(num)
      const digits = []

      for (let i = 0; i < str.length; i++) {
        digits.push({
          value: str[i],
          isDecimal: str[i] === '.'
        })
      }

      return digits
    }
  }
}
</script>

<style scoped>
.flip-counter {
  display: flex;
  align-items: center;
  line-height: 1;
}

.digit-container {
  margin-right: 2px; /* 数字间隔2px */
  position: relative;
  display: inline-block;
}

.digit {
  display: inline-block;
  text-align: center;
}

.digit.is-decimal {
  margin-right: 0;
}

/* 翻牌动画效果 */
.flip-enter-active, .flip-leave-active {
  transition: all 0.5s ease;
  transform-origin: bottom center;
  backface-visibility: hidden;
}

.flip-enter {
  transform: rotateX(90deg);
  opacity: 0;
}

.flip-enter-to {
  transform: rotateX(0deg);
  opacity: 1;
}

.flip-leave {
  transform: rotateX(0deg);
  opacity: 1;
}

.flip-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>
